import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Moves focus to the new page's heading after a client side route change.
 */
export const useSPANavigationFocus = () => {
  const { key, hash } = useLocation();
  const previousKey = useRef<string | null>(null);

  useEffect(() => {
    const wasAlreadyOnThisLocation = previousKey.current === key;
    const isFirstLocation = previousKey.current === null;
    previousKey.current = key;

    if (isFirstLocation || wasAlreadyOnThisLocation || hash) {
      return;
    }

    const main = document.querySelector('main');
    const target = main?.querySelector<HTMLElement>('h1') ?? main;

    window.scrollTo({ top: 0 });
    target?.setAttribute('tabindex', '-1');
    target?.focus({ preventScroll: true });
  }, [key, hash]);
};
